export default {
	state: {
		rosteringStaff: [],
		qualifications: ""
	},

	actions: {
		GetRosteringStaff(actionContext, parameters) {
			return new Promise(async (resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"]
						.post(
							`Service/GetRosteringStaff`,
							{
								ids: parameters.ids,
								stafftype: parameters.stafftype,
								availability: parameters.availability,
								position: parameters.position,
								additionaluserfields: parameters.additionaluserfields
							})
						.then(response => {
							var obj = actionContext.rootGetters["MopaneApi/getObjectArrayFromTables"](response.data)

							actionContext.commit("setRosteringStaff", obj.staff)
							actionContext.commit("setQualifications", obj.qualifications[0].qualifications)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setRosteringStaff(state, rosteringStaff) {
			state.rosteringStaff = rosteringStaff
		},
		setQualifications(state, qualifications) {
			state.qualifications = qualifications
		}
	},

	namespaced: true
}